import { ChangeEvent } from 'react';

import { GetStringKeys } from '../../../shared/types/get-string-keys.type';

export const setRadioGroupCheckedValue = <TFormikValuesModel>(
  setFieldValue: (
    field: string,
    value: number,
    shouldValidate?: boolean
  ) => void,
  name: GetStringKeys<TFormikValuesModel>
): ((event: ChangeEvent<HTMLInputElement>, value: string) => void) => {
  return function (event: ChangeEvent<HTMLInputElement>, value: string) {
    setFieldValue(name, +value);
  };
};
